
const styles = theme => ({
  root: {
    width: '100%',
    height: '100%',
    zIndex: 8000,
    marginLeft: 0,
    marginRight:0,
    marginTop: 20,
    marginBottom: 0,
  },
});

export default styles;



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/components/Candidate/styles.js